var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.349 2.667C8.983 2.667 3.016 8.635 3.016 16c0 7.366 5.967 13.334 13.333 13.334 7.366 0 13.333-5.968 13.333-13.334 0-7.365-5.967-13.333-13.333-13.333Zm6.548 9.134L20.71 22.113c-.161.731-.597.909-1.204.565l-3.333-2.457-1.608 1.548c-.177.178-.328.328-.672.328l.237-3.392 6.177-5.581c.269-.237-.06-.371-.414-.134l-7.634 4.806-3.29-1.027c-.716-.226-.732-.715.15-1.059l12.855-4.957c.596-.215 1.118.145.924 1.048Z",
    fill: "#E0E0E0"
  })));
};
export default SvgTelegram;